import { render, staticRenderFns } from "./IntegrationTerms.vue?vue&type=template&id=005d7f33&"
import script from "./IntegrationTerms.vue?vue&type=script&lang=js&"
export * from "./IntegrationTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports